// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"278":"cookies","443":"about"}[chunkId] + "." + {"278":"4df8c933","443":"99883482"}[chunkId] + ".js";
};